import React, { useEffect, useState } from 'react';
import { graphql } from 'babel-plugin-relay/macro';
import environment from '../relayEnvironment';
import { commitMutation } from 'react-relay';
import AssessmentForm from '../components/AssessmentForm';
import copenhagenPsychosocialPt2 from '../surveys/copenhagenPsychosocialPt2';
import { nextPage } from '../__utils__/nextPage';

const mutation = graphql`
  mutation CopenhagenPsychosocialPt2Mutation($input: PrePostMutationInput!) {
    prepostMutation(input: $input) {
      nextForm
    }
  }
`;

const CopenhagenPsychosocialPt2 = () => {
  const [formResponse, setFormResponse] = useState({});

  useEffect(() => {
    document.title = 'Wellbeing Assist - Copenhagen Psychosocial Questionnaire';
  });

  const onSubmit = (values, { setSubmitting }) => {
    const responses = Object.entries(values).map(([key, value]) => ({
      question: key,
      answer: value
    }));

    const variables = {
      input: { formName: 'CopenhagenPsychosocialPt2Form', responses: responses }
    };

    commitMutation(environment, {
      mutation,
      variables,
      onCompleted: response => {
        setSubmitting(false);
        sessionStorage.setItem('nextForm', response.prepostMutation.nextForm);
        nextPage();
      },
      onError: ({ error }) => {
        setFormResponse({ error });
      }
    });
  };

  return (
    <AssessmentForm
      onSubmit={onSubmit}
      formResponse={formResponse}
      heading={copenhagenPsychosocialPt2.heading}
      questions={copenhagenPsychosocialPt2.questions}
    />
  );
};

export default CopenhagenPsychosocialPt2;
